import SupportModalContent from './SupportModalContent';

export default SupportModalContent;
